var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"step-brindes"},[_c('Brinde',{attrs:{"item":_vm.item}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }